import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import 'bootstrap/dist/js/bootstrap.js';
import 'bootstrap/dist/css/bootstrap.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Hacer uso de Redux para poder tener un State global:
import { store } from './StoreRedux'
import { Provider } from 'react-redux'

// Se cargan las vistas que posteriormente se cargaran a las rutas
import App from './App';
import Layout from './pages/Layout';
import NoPage from './pages/NoPage';
import BuildingArea from './pages/BuildingArea';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<App />} />
          <Route path="/BuildingArea" element={<BuildingArea />} />
          <Route path="*" element={<NoPage />} />
        </Route>
      </Routes>
    </Provider>
  </BrowserRouter>
);

reportWebVitals();